import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import FetchPlease from 'fetch-please'
import debounce from 'debounce'
import { SearchSelectBox } from 'containers'
import { getAutocompleteService } from 'apis/google-maps'
import { fetchGeoDataFromAddress } from 'apis/geo'

import { Select } from "components"
import fetchAPI from "AtomicUtils/fetchAPI"

import dealerSearchBoxNZStyles from "./dealer-search-box-nz.less"
import classnames from "classnames"

const Typeahead = require('react-typeahead').Typeahead;

import { noop } from 'utils'
import { gtmEvent } from 'higher-order-components'
import Highlighter from 'react-highlight-words'
// import googleAutoComplete from 'AtomicUtils/googleAutoComplete'

class DealerSearchBoxNZ extends PureComponent {
  constructor(props) {
    super(props)
    // this.google = new googleAutoComplete()
    this.state = {
      autocompleteItems: [],
      dealerSearch: [],
      searchOptions: [],
      currentSearchValue: (props.value && props.value.toString()) || '',
      didEdit: false,
      inputValue: '',
      selectedRegion: null,
      dealers: [],
      success: false,
      errorMessage: null
    }

    this.dealerSearch = new FetchPlease(props.dealerSearchEndPoint, {
      timeout: 3000,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    this.debouncedLocationSearchToState = debounce(
      search => this.doLocationSearchToState(search),
      500
    )
  }

  // Api fns - consider reafactoring and moving these out of component.

  getAutocompleteService = async () => {
    if (this.autocompleteService && this.autocompleteOK !== undefined) {
      return this.autocompleteService
    }

    try {
      const { autocompleteService, statusCodes } = await getAutocompleteService()

      this.autocompleteService = autocompleteService
      this.autocompleteOK = statusCodes.OK

      return this.autocompleteService
    } catch (error) {
      console.warn(error)
      throw error
    }
  }

  searchOverride = (search) => {
    this.doLocationSearchToState(search).then((results = []) => {
      const item = results.find(result => result.label === search) || results[0]
      this.setState({ currentSearchValue: item ? String(item.value) : '' }, () => {
        this.handleSelectChange(item, true)
      })
    })
  }

  doDealerSearch = (search) => {
    this.dealerSearch && this.dealerSearch.abort()
    return this.dealerSearch.post('', { searchText: search }).then(({ data }) => data)
  }

  doPredictionSearch = search => this.getAutocompleteService()
    .then(service => new Promise((resolve, reject) => {
      service.getPlacePredictions(
        {
          input: search,
          componentRestrictions: this.props.componentRestrictions || null,
          types: ['(regions)']
        },
        (predictions, status) => {
          if (status !== this.autocompleteOK) reject(status)
          else {
            resolve(predictions.filter(({ types }) =>
              ['colloquial_area'].some(type => types.indexOf(type) === -1) &&
              ['postal_code', 'locality'].some(type => types.indexOf(type) !== -1)))
          }
        }
      )
    }))
    .catch(error => console.warn('Google response:', error))

  doLocationSearchToState = async (search) => {
    let { dealerSearch = [], autocompleteItems = [] } = this.state

    try {
      const [dealerResults, autocompleteResults] = await Promise.all([
        this.doDealerSearch(search),
        this.doPredictionSearch(search)
      ])

      dealerSearch = dealerResults
      autocompleteItems = autocompleteResults
    } catch (error) {
      console.warn(error)
    }

    const searchOptions = this.createSearchOptions({
      dealerSearch,
      autocompleteItems
    })

    this.setState({
      dealerSearch,
      autocompleteItems,
      searchOptions
    })

    return searchOptions
  }

  doAutoSearchFromState = () => {
    if (!this.state.currentSearchValue) return

    this.doLocationSearchToState(this.state.currentSearchValue).then(([firstResult = {}] = []) =>
      this.setState({
        currentSearchValue: firstResult.value || ''
      }))
  }

  //

  componentDidMount() {
    if (window.location.href.indexOf('dealerCode') != -1) {
      this.setState({
        selectedRegion: localStorage.getItem('selectedRegion') || null
      })
    } else {
      this.setState({
        selectedRegion: null
      })
    }
  }

  componentWillMount() {
    const { searchOverride } = this.props
    if (searchOverride) {
      this.searchOverride(searchOverride)
    }
    this.doAutoSearchFromState()
  }

  componentWillReceiveProps({ value, searchOverride }) {
    if (!this.state.didEdit && value) {
      const value = value.toString()
      this.setState({ currentSearchValue: value }, () => {
        this.doAutoSearchFromState()
      })
    }
    if (searchOverride !== this.props.searchOverride) {
      this.searchOverride(searchOverride)
    }
  }

  clearAutocomplete = () => {
    this.setState({
      autocompleteItems: [],
      dealerSearch: [],
      searchOptions: [],
      currentSearchValue: ''
    })
  }

  handleInputChange = (value) => {
    this.setState({ didEdit: true, inputValue: value })

    if (!value) {
      return
    }

    this.debouncedLocationSearchToState(value)
  }

  handleSelectChange = (props, isOnLoad) => {
    this.setState({ didEdit: true })
    const { value } = props || {}

    if (!props || !value) {
      this.clearAutocomplete()
      return
    }

    let currentItem = this.getCurrentItem(value)
    //var place = new{}
    if (currentItem && currentItem.place_id) {
      fetchGeoDataFromAddress({
        placeId: currentItem.place_id
      }).then(({ addressDetails }) => {
        currentItem = addressDetails
        this.props.onChange(currentItem, isOnLoad)
      })

      this.props.onSelect(currentItem.description, currentItem.place_id)
    } else if (currentItem && currentItem.value) {
      currentItem = { ...currentItem, dealerCode: currentItem.value }
      this.props.onChange(currentItem, isOnLoad)
    } else {
      this.props.onChange(currentItem, isOnLoad)
    }
    // We don't want a GTM event to fire on first load, hence the checking.
    if (!isOnLoad && this.state.searchOptions[value]) {
      this.props.gtmEvent({
        gtmID: this.props.gtmMapping.ENTER_LOCATION,
        gtmPayload: {
          location: this.state.searchOptions[value].label
        }
      })
    }

    this.setState({ currentSearchValue: value })
  }

  createSearchOptions = ({ dealerSearch = [], autocompleteItems = [] }) => {
    if (dealerSearch) {
      const dealersCount = dealerSearch.length
      return dealerSearch
        .map(({ display }, index) => ({
          value: index.toString(),
          label: display
        }))
        .concat(autocompleteItems.map(({ description }, index) => ({
          value: (index + dealersCount).toString(),
          label: description
        })))
    }
    return []
  }

  getCurrentItem = (searchValue) => {
    const { dealerSearch = [], autocompleteItems = [] } = this.state
    return dealerSearch.concat(autocompleteItems)[parseInt(searchValue, 10)]
  }

  render() {
    const { placeholder } = this.props
    const { searchOptions, currentSearchValue } = this.state

    return (
      <div key={'DealerSearchBoxNZ'}>
        <div style={styles.dropDown}>
          <Select
            defaultValue={{value: this.state.selectedRegion}}
            label={selectOptions.label}
            options={selectOptions.regions}
            onChange={value => { this.handleRegionChange(value) }} />
        </div>

        {this.state.dealers.length > 0 && (
        <div style={styles.typeahead}>
          <Typeahead
            placeholder="Type to filter then select a dealer"
            showOptionsWhenEmpty={true}
            options={this.state.dealers.map((dealer) => {
              return dealer.name
            })}
            maxVisible={10}
            onOptionSelected={dealer => this.handleTypeaheadSelect(dealer)}
            ref="typeahead"
            customClasses={{
              input: classnames({[dealerSearchBoxNZStyles.TypeaheadInput]: true}),
              results: classnames({[dealerSearchBoxNZStyles.TypeaheadResults]: true}),
              listItem: classnames({[dealerSearchBoxNZStyles.TypeaheadListItem]: true}),
            }} />
        </div>
        )}
      </div>
    )
  }

  handleTypeaheadSelect = (dealer) => {
    let selectedDealer = this.state.dealers.find((item) => {
      return item.name === dealer
    })

    if (selectedDealer && !this.props.noMap) {
      this.props.handleNZLocations([selectedDealer])
    }

    if (this.props.selectDealerVariant) {
      this.props.selectDealer(selectedDealer);
    }

    document.activeElement.blur()
  }

  getUrlParameter = (name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  handleRegionChange = async (region) => {
    this.setState({
      selectedRegion: region
    })

    localStorage.setItem('selectedRegion', region.value)

    // if local
    let url = '';
    let port = window.location.port;

    if (port == 4000) {
      url = 'http://www.mocky.io/v2/5dedc1ca33000052002b91d9'
    } else {
      url = '/api/dealer-search-by-region'
    }

    await fetchAPI({
      method: "POST",
      url: url,
      body: {
        region: region.value
      }
    })
      .then(async (response) => {
        const json = await response.json()
        const { success, errorMsg } = json
        if (!success) {
          this.setState({
            errorMessage: errorMsg,
            loading: false
          })
        } else {
          // successful
          let department = ''
          let searchType = this.props.searchType || ''
          let filteredData = []

          let qs = this.getUrlParameter("department") || ''

          if (searchType && searchType != '') {
            department = searchType.toUpperCase()
          } else if (qs && qs != '') {
            department = qs.toUpperCase()
          } else {
            department = 'SALES'
          }

          let indexVal = ''
          if (department == 'SALES') indexVal = 0
          if (department == 'SERVICE') indexVal = 1
          if (department == 'PARTS') indexVal = 2
          localStorage.setItem('activeTabIndex', indexVal)

          filteredData = json.data.filter((item) => {
            let departmentMatch = item.departments.find((dep) => {
              return dep.name.toUpperCase() === department
            })

            if (departmentMatch) return item
          })

          this.setState({
            loading: false,
            success: true,
            dealers: filteredData
          })

          this.refs.typeahead.setState({
            entryValue: '',
            selection: null,
            selectionIndex: null,
            visible: []
          })

          if (!this.props.noMap) this.props.handleNZLocations(filteredData, json.data)
          this.refs.typeahead.focus()
        }
      })
      .catch((response) => {
        this.setState({
          errorMessage: response.message || `Failed with status ${response.status}`,
          loading: false
        })
      })
  }
}

DealerSearchBoxNZ.propTypes = {
  dealerSearchEndPoint: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  componentRestrictions: PropTypes.object,
  searchOverride: PropTypes.string,
  gtmMapping: PropTypes.object,
  gtmEvent: PropTypes.func,
  handleNZLocations: PropTypes.func,
  noMap: PropTypes.bool,
  selectDealerVariant: PropTypes.bool,
  selectDealer: PropTypes.func,
  searchType: PropTypes.string
}

DealerSearchBoxNZ.defaultProps = {
  dealerSearchEndPoint: '',
  placeholder: 'Enter your postcode, suburb or Dealer name',
  value: '',
  onSelect: noop,
  onChange: noop,
  componentRestrictions: {},
  gtmMapping: {}
}

const styles = {
  dropDown: {
    maxWidth: "400px",
    width: "100%",
    margin: "0 auto 1.8em"
  },
  typeahead: {
    maxWidth: "400px",
    width: "100%",
    margin: "1.8em auto"
  }
}

const selectOptions = {
  label: "Region",
  regions: [
    { name: "Auckland" },
    { name: "Bay of Plenty" },
    { name: "Canterbury" },
    { name: "North Island Central" },
    { name: "North Island Lower" },
    { name: "Northland" },
    { name: "Otago" },
    { name: "South Island Upper" },
    { name: "Southland" },
    { name: "Waikato" }
  ]
}

export default gtmEvent()(DealerSearchBoxNZ)



// WEBPACK FOOTER //
// ./src/components/form-elements/dealer-search-box-nz/index.jsx